import { useQuery } from '@tanstack/react-query';
import { PARADEX_API_BASE_URL } from '#/routes';
import { RawMarketSummary } from './types';

interface GetMarketsSummaryRespRaw {
  readonly results: readonly RawMarketSummary[];
}

export default function useParadexMarketSummary() {
  const { status, data: marketSummary } = useQuery({
    queryKey: ['paradex-market-summary'],
    queryFn: async () => {
      const res = await fetch(
        `${PARADEX_API_BASE_URL}/v1/markets/summary?market=ALL`,
      );
      const marketsSummary = (await res.json()) as GetMarketsSummaryRespRaw;
      const marketSummaryMap = Object.fromEntries(
        marketsSummary.results.map((market) => [market.symbol, market]),
      );

      return marketSummaryMap;
    },
    refetchInterval: 3000,
  });

  const btcMarket = marketSummary?.['BTC-USD-PERP'];
  const ethMarket = marketSummary?.['ETH-USD-PERP'];

  return { status, markets: { btcMarket, ethMarket } };
}
